module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('bsf-smenu', _vm._l((_vm.router), function(sidemenu, index) {
    return _c('bsf-smenuli', {
      attrs: {
        "icon": sidemenu.iconname,
        "label": sidemenu.label,
        "route": sidemenu.path
      }
    }, [(!!sidemenu.hasmsg) ? _c('bsf-badges', {
      attrs: {
        "imp": sidemenu.imp,
        "val": sidemenu.msg
      },
      slot: "label"
    }) : _vm._e(), _vm._v(" "), (!!sidemenu.crouter) ? _c('bsf-smenu', {
      slot: "menu"
    }, _vm._l((sidemenu.crouter), function(sidemenuc, index) {
      return _c('bsf-smenuli', {
        attrs: {
          "label": sidemenuc.label,
          "route": sidemenuc.path
        }
      }, [_c('bsf-badges', {
        attrs: {
          "imp": sidemenuc.imp,
          "val": sidemenuc.msg
        },
        slot: "label"
      })])
    })) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-4065d86f!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 308
// module chunks = 2